var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLinkDy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7.45817C13.4928 7.45817 12.0574 6.95617 10.9091 6.09562V12.2629C10.9091 15.4183 8.4689 18 5.45454 18C2.44019 18 0 15.4183 0 12.2629C0 9.10757 2.44019 6.5259 5.45454 6.5259C5.74163 6.5259 6.02871 6.5259 6.31579 6.59761V9.89641C6.02871 9.8247 5.74163 9.75299 5.45454 9.75299C4.09091 9.75299 3.01435 10.9004 3.01435 12.3347C3.01435 13.7689 4.09091 14.9163 5.45454 14.9163C6.81818 14.9163 7.89474 13.7689 7.89474 12.3347V0H10.9091C10.9091 2.36653 12.7033 4.30279 15 4.30279V7.45817Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLinkDy);
export default __webpack_public_path__ + "static/media/nav_link_dy.34756dff005603cfa7591faa65d704ae.svg";
export { ForwardRef as ReactComponent };